var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyPledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31396 11.0191L8.89997 16.189L22.7988 7.22907L14.9877 2L1.31396 11.0191Z",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2321 3.50429L16.9123 3.66419C15.3844 4.65907 13.1519 3.66419 13.1519 3.66419C13.1519 3.66419 12.8795 3.52798 12.8262 3.42731",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6313 8.62069C20.4248 8.44741 20.2593 8.23051 20.1466 7.9856C20.034 7.74068 19.977 7.47384 19.9798 7.20427C19.9827 6.93471 20.0452 6.66912 20.163 6.42662C20.2808 6.18413 20.4508 5.97075 20.6609 5.80185",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92798 14.8447C6.92798 14.8447 8.47953 13.6604 11.0733 14.7855",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45752 9.62137C3.45752 9.62137 5.0446 11.1788 3.45752 12.4639",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.6713L9.00054 17.853L23 8.82208",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.3117L9.00054 19.3986L22.9763 10.4328",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.964L9.00054 21.1279L22.9763 12.0496",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35571 7.36539L14.6795 10.9067",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9261 7.47196C11.9261 7.47196 9.43294 7.34168 9.42701 8.57344C9.42109 9.8052 11.476 9.37882 11.9261 9.16563C12.6367 8.85769 14.7745 8.1589 14.5436 9.9947C14.3718 10.8771 12.2814 10.7823 12.2814 10.7823",
    stroke: "#61A578",
    strokeWidth: 0.795784,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPledge);
export default __webpack_public_path__ + "static/media/money_pledge.b55cba89ccfe602771de9ec14772acfa.svg";
export { ForwardRef as ReactComponent };